import React from 'react';
import {
  Node,
  Title,
  Wrapper,
  Content,
  Background,
  SurfaceName,
  AnswerOptionLabel,
  QuestionnaireQuestion,
  QuestionnaireContent,
} from './style';
import { SurfaceNodeType } from 'graphql/types';
import { defaultNodeDimensions } from 'components/canvas/components/nodes';

function NodePreview(props) {
  const { node } = props;
  console.log('NODE PREVIEW ', node);
  switch (node.type) {
    case SurfaceNodeType.Text:
      return <TextPreview {...props} />;
    case SurfaceNodeType.Note:
      return <NotePreview {...props} />;
    case SurfaceNodeType.Document:
    case SurfaceNodeType.Image:
      return <DocumentPreview {...props} />;
    case SurfaceNodeType.SubSurface:
      return <SurfacePreview {...props} />;
    case SurfaceNodeType.Protocol:
      return <ProtocolPreview {...props} />;
    case SurfaceNodeType.Questionnaire:
      return <QuestionnairePreview {...props} />;
    case SurfaceNodeType.DocumentSnippet:
      return <TextPreview {...props} />;
    case SurfaceNodeType.TextSnippet:
      return <TextPreview {...props} />;

    default:
      return null;
  }
}

function SurfacePreview({ node, isSelected, selectedColor }) {
  return (
    <Content selectedColor={selectedColor} $isSurfaceNode>
      <Background isSelected={isSelected} selectedColor={selectedColor}>
        <SurfaceName>{node.name}</SurfaceName>
      </Background>
    </Content>
  );
}

function TextPreview({ node, isSelected, selectedColor }) {
  const { text } = defaultNodeDimensions;

  return (
    <Node>
      <Title width={text.width}>{node.name}</Title>
      <Content
        isSelected={isSelected}
        selectedColor={selectedColor}
        width={text.width}
        height={text.height}
        $isTextNode>
        {node.text}
      </Content>
    </Node>
  );
}

function NotePreview({ node, isSelected, selectedColor, risk }) {
  const { note } = defaultNodeDimensions;

  return (
    <Node>
      <Title width={note.width}>{node.name}</Title>
      <Content
        isSelected={isSelected}
        selectedColor={selectedColor}
        width={note.width}
        height={note.height}
        $isNoteNode>
        {node.text}
      </Content>
    </Node>
  );
}

function QuestionnairePreview({ node, isSelected, selectedColor }) {
  const { questionnaire } = defaultNodeDimensions;

  return (
    <Node>
      <Title width={questionnaire.width}>{node.name}</Title>
      <Content
        isSelected={isSelected}
        selectedColor={selectedColor}
        width={questionnaire.width}
        height={questionnaire.height}
        $isQuestionnaireNode>
        <QuestionnaireContent spaceBetween>
          <QuestionnaireQuestion>{node.question}</QuestionnaireQuestion>
          <AnswerOptionLabel type={node.answerType} />
        </QuestionnaireContent>
      </Content>
    </Node>
  );
}

function ProtocolPreview({ node, isSelected, selectedColor }) {
  const { protocol } = defaultNodeDimensions;

  return (
    <Node>
      <Title width={protocol.width}>{node.name}</Title>
      <Content
        isSelected={isSelected}
        selectedColor={selectedColor}
        width={protocol.width}
        height={protocol.height}
        $isProtocolNode>
        {node.contains && (
          <Wrapper>
            <NodePreview node={node.contains} isSelected={false} />
          </Wrapper>
        )}
      </Content>
    </Node>
  );
}

function generateImagePreview(url, width, height) {
  if (url.includes('blob:') && url.includes(window.location.host)) {
    return url;
  }

  return `https://images.weserv.nl/?url=${encodeURIComponent(
    url,
  )}&w=${width}&h=${height}&fit=contain&cbg=transparent`;
}

function DocumentPreview({ node, isSelected, selectedColor }) {
  const { document } = defaultNodeDimensions;
  return (
    <Node>
      <Title width={document.width}>{node.name}</Title>
      <Content
        isSelected={isSelected}
        selectedColor={selectedColor}
        width={document.width}
        height={document.height}
        $isDocumentNode>
        <img
          src={generateImagePreview(node.url, document.width, document.height)}
        />
      </Content>
    </Node>
  );
}

export default NodePreview;
